module.exports = __webpack_public_path__ + "img/T2D_rc_12.4ee2fa60.png";